import { render, staticRenderFns } from "./TicketPreview.vue?vue&type=template&id=2e20bd50&scoped=true"
import script from "./TicketPreview.vue?vue&type=script&lang=js"
export * from "./TicketPreview.vue?vue&type=script&lang=js"
import style0 from "./TicketPreview.vue?vue&type=style&index=0&id=2e20bd50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20bd50",
  null
  
)

export default component.exports